import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../graphql/types.generated';
export type UpdateMarksAndNumbersMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateMarksAndNumbersInput;
}>;

export type UpdateMarksAndNumbersMutationResult = { __typename?: 'Mutation' } & {
  updateMarksAndNumbers: { __typename?: 'UpdateMarksAndNumbersPayload' } & {
    errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
  };
};

export const UpdateMarksAndNumbersDocument = gql`
  mutation updateMarksAndNumbers($input: UpdateMarksAndNumbersInput!) {
    updateMarksAndNumbers(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
